import _ from 'lodash';

export default {
    computed: {
        liveUrl() {
            return `/api/v1/contacts/live/${this.liveParamId}?expand[]=networks.network&expand[]=primary_address`;
        },
        liveId() {
            return _.get(this.contact, 'live_url');
        },
        liveParamId() {
            return this.$route.params.live_url;
        },
        isContactDirty() {
            return this.liveId !== this.liveParamId;
        },
        contactUrl() {
            return `/api/v1/contacts/${this.contactId}`;
        },
        contact() {
            return this.$root.v2.contact;
        },
        contactId() {
            return _.get(this.contact, 'id');
        },
    },
    methods: {
        loadContact(force = false) {
            // TODO: testing reloading fresh data every time to prevent state related bugs.
            // if (!force && !this.isContactDirty) {
            //     return Promise.resolve();
            // }

            return this.$http.get(this.liveUrl)
                .then(res => this.$root.v2.contact = res.data);

        },
    }
}
